(function() { module.exports = this["wp"]["coreData"]; }());